import { NgFor, NgIf, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavigationLink } from '@domgen/dgx-fe-common';
import { ButtonTextComponent } from '@domgen/dgx-fe-components/button';
import { TextHighlightDirective } from '@domgen/dgx-fe-components/decoration';
import {
  GridContainerComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import {
  VideoBlock,
  VideoListComponent,
} from '@domgen/dgx-fe-components/media';
import { NavigationLinkDirective } from '@domgen/dgx-fe-components/navigation';
import { TranslatePipe } from '@domgen/dgx-fe-i18n';
import { provideTranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { Provider } from '@angular/core';
import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { ArticleListComponent } from '@domgen/dgx-fe-components/content';
import { YoutubePlayerModule } from '@self-fix/feature-components';

export interface ArticleBlock {
  title: string;
  snippet: string;
  navigationLink: NavigationLink;
}
export interface ArticleSearchResults {
  articles: ArticleBlock[];
  title: string;
  viewMoreLink?: NavigationLink;
}
export interface VideoSearchResults {
  viewMoreLink?: NavigationLink;
  title: string;
  videos: VideoBlock[];
}

export const searchResultsTranslationDictionaryMapping = {
  [LocaleId.English_GreatBritain]: {
    VIEW_MORE: 'View more',
  },
  [LocaleId.English_Ireland]: {
    VIEW_MORE: 'View more',
  },
  [LocaleId.English_US]: {
    VIEW_MORE: 'View more',
  },
};

export function provideSearchResultsI18n(): Provider {
  return [
    provideTranslationDictionaryMapping(
      searchResultsTranslationDictionaryMapping
    ),
  ];
}

@Component({
  selector: 'dgx-components-keyword-search-results-block',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    TextHighlightDirective,
    NavigationLinkDirective,
    SlicePipe,
    ArticleListComponent,
    VideoListComponent,
    IconComponent,
    ButtonTextComponent,
    GridContainerComponent,
    GridSectionComponent,
    TranslatePipe,
    ButtonTextComponent,
    YoutubePlayerModule,
  ],
  providers: [provideSearchResultsI18n()],
  templateUrl: './keyword-search-results-block.component.html',
  styleUrls: ['./keyword-search-results-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeywordSearchResultsBlockComponent {
  videoList: VideoBlock[] = [];
  articleList: ArticleBlock[] = [];
  viewMoreVideosLink?: NavigationLink;
  viewMoreArticlesLink?: NavigationLink;
  videosTitle = '';
  articlesTitle = '';

  @Input() searchTerm?: string;
  @Input() displayableItems = 5;
  @Input() set videos(videos: VideoSearchResults | undefined) {
    if (videos?.videos) {
      this.viewMoreVideosLink =
        videos.videos.length > this.displayableItems
          ? videos.viewMoreLink
          : undefined;

      this.videoList = videos.videos;
      this.videosTitle = videos.title;
    }
  }
  @Input() set articles(articles: ArticleSearchResults | undefined) {
    if (articles?.articles) {
      this.viewMoreArticlesLink =
        articles.articles.length > this.displayableItems
          ? articles.viewMoreLink
          : undefined;
      this.articleList = articles.articles;
      this.articlesTitle = articles.title;
    }
  }
}
